import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findRequests = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/service-requests${query}`,
    {
      headers,
    },
  );
};

export const findRequestById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/service-requests/${id}`,
    {
      headers,
    },
  );
};

export const createRequest = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_INFO_API_URL}/service-requests`,
    data,
    {
      headers,
    },
  );
};

export const updateRequest = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_INFO_API_URL}/service-requests/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deleteRequest = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_INFO_API_URL}/service-requests/${id}`,
    {
      headers: headers,
    },
  );
};

export const findOrdersByRequestId = (headers, id, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/service-requests/${id}/orders${query}`,
    {
      headers,
    },
  );
};

export const createOrder = (headers, id, data) => {
  return axios.post(
    `${process.env.REACT_APP_INFO_API_URL}/service-requests/${id}/orders`,
    data,
    {
      headers,
    },
  );
};

export const findMedicationRequestByRequestId = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/service-requests/${id}/medication-request`,
    {
      headers,
    },
  );
};

export const createMedicationRequest = (headers, id, data) => {
  return axios.post(
    `${process.env.REACT_APP_INFO_API_URL}/service-requests/${id}/medication-request`,
    data,
    {
      headers,
    },
  );
};
